import { IParameter } from "../types";
import { IGetParamsGET_ALL_VEHICLES, IGetParamsGET_VEH_COORDS } from "./types";
function getParamsGET_VEH_COORDS({ NVEH_ID, NPART_ID }: IGetParamsGET_VEH_COORDS): IParameter[] {
    return [
        { name: "NVEH_ID", value: NVEH_ID ?? 0 },
        { name: "NPART_ID", value: NPART_ID ?? 0 },
    ];
}

function getParamsGET_ALL_VEHICLES({
    NACC_ID,
    NFIRST_ROWNUM = 1,
    NLAST_ROWNUM = 2000000,
    VVEH_TYPE_ID,
    NRL_ID
}: IGetParamsGET_ALL_VEHICLES): IParameter[] {
    return [
        { name: "NACC_ID", value: NACC_ID ?? null },
        { name: "NFIRST_ROWNUM", value: NFIRST_ROWNUM },
        { name: "NLAST_ROWNUM", value: NLAST_ROWNUM },
        { name: "VVEH_TYPE_ID", value: VVEH_TYPE_ID ?? null },
        { name: "NRL_ID", value: NRL_ID ?? null }
    ];
}

export {
    getParamsGET_VEH_COORDS,
    getParamsGET_ALL_VEHICLES,
};